import request from '@/config/axios'

// AI 员工 VO
export interface AiEmployeeVO {
  id: number
  employeeCode: string
  employeeName: string
  employeeType: string
  deptId?: number
  agentId?: number
  avatar?: string
  description?: string
  skillTags?: string[]
  isPublic?: boolean
  conversationLimit?: number
  greetingMessage?: string
  exampleQuestions?: string[]
  status: number
  sort: number
  remark?: string
  skillIds?: number[]
  knowledgeIds?: number[]
  createTime?: Date
}

// AI 员工 API
export const EmployeeApi = {
  // 获得员工分页
  getEmployeePage: async (params: any) => {
    return await request.get({ url: '/ai/employee/page', params })
  },

  // 获得员工详情
  getEmployee: async (id: number) => {
    return await request.get({ url: '/ai/employee/get?id=' + id })
  },

  // 创建员工
  createEmployee: async (data: AiEmployeeVO) => {
    return await request.post({ url: '/ai/employee/create', data })
  },

  // 更新员工
  updateEmployee: async (data: AiEmployeeVO) => {
    return await request.put({ url: '/ai/employee/update', data })
  },

  // 删除员工
  deleteEmployee: async (id: number) => {
    return await request.delete({ url: '/ai/employee/delete?id=' + id })
  },

  // 获得员工下拉列表
  getEmployeeSimpleList: async () => {
    return await request.get({ url: '/ai/employee/simple-list' })
  },

  // 工作台运营汇总
  getDashboardStats: async () => {
    return await request.get({ url: '/ai/employee/stats/dashboard' })
  }
}
